import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import authenticationApi from '../../../services/api/authentication';

export default function useFederatedSignIn() {
  const redirectUrl = useSelector((state) => state?.login?.redirectUrl);

  return useCallback(
    (providerName) => {
      return authenticationApi.federatedSignIn(providerName, redirectUrl);
    },
    [redirectUrl],
  );
}
